import {
  ScanBarcode,
  CalendarDays,
  Search,
  CirclePlus,
  BarChart2,
  ScrollText,
  Users,
  Settings2,
  Barcode,
  FileText,
  RefreshCw,
  MailWarning,
  LogOut,
  type LucideIcon,
} from "lucide-react";
import {
  Sidebar as LibSidebar,
  type SidebarNavGroup,
} from "@marekl/adminer/shell";
import type { User, Role } from "../../auth/queries";
import { Brand } from "../../components/Brand";

interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
}

interface NavGroup {
  label: string;
  requiredRoles: Role[];
  items: NavItem[];
}

const NAV_GROUPS: NavGroup[] = [
  {
    label: "Recepce",
    requiredRoles: ["reception", "manager", "superadmin"],
    items: [
      { to: "/dashboard", label: "Skenování", icon: ScanBarcode },
      { to: "/daily-overview", label: "Přehled dne", icon: CalendarDays },
      { to: "/vouchers", label: "Vouchery", icon: Search, end: true },
      { to: "/certificates", label: "Certifikáty", icon: FileText, end: true },
      { to: "/vouchers/sale", label: "Prodej voucheru", icon: CirclePlus },
    ],
  },
  {
    label: "Správce",
    requiredRoles: ["manager", "superadmin"],
    items: [
      { to: "/reports", label: "Reporty", icon: BarChart2 },
      { to: "/audit-log", label: "Audit log", icon: ScrollText },
      { to: "/eshop-sync", label: "Synchronizace e-shopu", icon: RefreshCw, end: true },
      { to: "/email-problems", label: "Nedoručené e-maily", icon: MailWarning, end: true },
    ],
  },
  {
    label: "Superadmin",
    requiredRoles: ["superadmin"],
    items: [
      { to: "/users", label: "Uživatelé", icon: Users },
      { to: "/config", label: "Konfigurace", icon: Settings2 },
      { to: "/barcode-bank", label: "Banka kódů", icon: Barcode },
    ],
  },
];

const ROLE_LABEL: Record<Role, string> = {
  reception: "Recepce",
  manager: "Správce",
  superadmin: "Superadmin",
};

interface SidebarProps {
  user: User;
  onLogout: () => void;
}

export function Sidebar({ user, onLogout }: SidebarProps) {
  const groups: SidebarNavGroup[] = NAV_GROUPS.filter((g) =>
    g.requiredRoles.includes(user.role),
  ).map((g) => ({
    label: g.label,
    items: g.items.map(({ to, label, icon: Icon, end }) => ({
      to,
      label,
      end,
      icon: <Icon aria-hidden="true" />,
    })),
  }));

  return (
    <LibSidebar
      groups={groups}
      user={{
        displayName: user.display_name || user.username,
        roleLabel: ROLE_LABEL[user.role],
      }}
      profileHref="/profile"
      onLogout={onLogout}
      logoutIcon={<LogOut aria-hidden="true" />}
      brand={<Brand />}
    />
  );
}
